import React from 'react';

const SongDetails = ({title, composers, artist}) => {

  return (
    <div className="text-center">
      <h2 className='mb-25'>{title}</h2>
      <p>Composer(s): {composers}</p>
      <p>Artist(s): {artist}</p>
    </div>
  );
};

export default SongDetails;
